import React, { Component } from 'react';
import { SortingState, IntegratedSorting, PagingState, IntegratedPaging, SearchState, IntegratedFiltering, DataTypeProvider } from '@devexpress/dx-react-grid';
import { Grid, Table, TableHeaderRow, SearchPanel, Toolbar, TableColumnVisibility } from '@devexpress/dx-react-grid-bootstrap4';
import { PagingPanel } from '@devexpress/dx-react-grid-material-ui';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import styles from '../Report/Report.less';
import deliveryStyles from './Delivery.less';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import ReactExport from "react-data-export";
const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
import eyeIconUrl from '../../../static/images/eyeIcon.png';
import eyeIconWhiteUrl from '../../../static/images/eyeIcon-white.png';
import { connect } from 'react-redux';
import * as commonActions from './../../actions/commonActions';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as authActions from './../../redux/modules/auth';
import ReactDOM from 'react-dom';
import { convertEpochToEventTime, getFormattedRate, getMinMaxFractionDigits, setDirection, toEpoch } from './../../utils/utils';
import ViewStatus from './ViewStatus.js'
import { getPath } from './../../actions/commonActions';
import { Button } from 'react-bootstrap';
import * as filesaver from './../../actions/FileSaver.js'
import moment from 'moment';
import Modal from 'react-modal';
import OpenPositions from './OpenPositions.js';

const directionData = [
  { classNames: 'pendingTableOpenPos', elementType: 'normal', applyTo: 'single', tagNames: 'div' },
  { classNames: 'pendingReqExportDiv', elementType: 'normal', applyTo: 'single', tagNames: 'div' },
  { classNames: 'exportfileBaracc', elementType: 'normal', applyTo: 'all', tagNames: 'div' },
  { classNames: 'delPenExport', elementType: 'normal', applyTo: 'all', tagNames: 'div' },
  { classNames: 'reportsTblGrid', elementType: 'normal', applyTo: 'all', tagNames: 'div' },
];

const baseColumnsExtensions = [
  { columnName: 'DRN', width: 90 },
  { columnName: 'AD', width: 90 },
  { columnName: 'CMDTY', width: 90 },
  { columnName: 'TOTAL_GQ', width: 90, align: 'right',  },
  { columnName: 'TOTAL_PAMT', width: 90, align: 'right' },
  { columnName: 'LOC_DESC', width: 90 },
  { columnName: 'COLLECTIONDATETIME', width: 90 },
  { columnName: 'RMK', width: 90, wordWrapEnabled: true },
  { columnName: 'STATUSDESC', width: 90 },
  { columnName: 'TS', title: i18next.t("eventTime") },
  { columnName: '', id: 'action', width: 90 },
];

const columnsToFormat = { TOTAL_GQ: 'stockQtyFormat', TOTAL_PAMT: 'stockRateFormat' };

const formatExcelValue = (val, row, col) => {

  //Converts array values to a string with line breaks for Excel export
  if (Array.isArray(val)) {
    return {
      value: val.join('\n'),
      style: { alignment: { wrapText: true } }
    };
  }

  const formatStyle = { style: { numFmt: row[columnsToFormat[col.name]] } }
  const value = val === null || val === undefined ? '' : val
  //For other values, return as it is
  if (col.name in columnsToFormat) {
    return { value, ...formatStyle };
  }
  return { value };
};

const NoDataCell = props => (
  <Table.NoDataCell {...props} className="noDataCell" />
);

@connect(
  (state) => ({
    selectedCssColorTheme:
      state.dashboardRoot.commonReducer.selectedCssColorTheme,
    selectedCssColor: state.dashboardRoot.commonReducer.selectedCssColor,
    selectedLang: state.dashboardRoot.commonReducer.selectedLang,
    language: state.dashboardRoot.commonReducer.language,
    userDetail: state.auth.userDetail,
  }),
  {
    ...commonActions,
    ...instrumentListActions,
    ...authActions,
  }
)
export default class PendingComponent extends Component {
  static propTypes = {
    language: PropTypes.string,
    selectedLang: PropTypes.string.isRequired,
    selectedCssColor: PropTypes.string,
    showViewModal: false,
    deliveryData: PropTypes.array,
  };

  afterOpenModal() {
    try {
      const thisComponent = this.refs.errorMSG;
      ////const allCssStyleRules = this.props.selectedCssColorTheme;
      const elementsData = [
        {
          classNames: "closeBtn",
          elementType: "normal",
          applyTo: "single",
          tagNames: "button",
        },
        {
          classNames: "button-l",
          elementType: "normal",
          applyTo: "single",
          tagNames: "button",
        },
      ];
      // applyStyle(thisComponent, allCssStyleRules, elementsData);
      const directionData = [
        {
          classNames: "header",
          elementType: "normal",
          applyTo: "all",
          tagNames: "div",
        },
        {
          classNames: "commonCloseIcon",
          elementType: "normal",
          applyTo: "all",
          tagNames: "div",
        },
        {
          classNames: "commonMsgDir",
          elementType: "normal",
          applyTo: "all",
          tagNames: "div",
        },
        {
          classNames: "button-l",
          elementType: "normal",
          applyTo: "single",
          tagNames: "button",
        },
      ];
      setDirection(thisComponent, directionData, this.props.selectedLang);
      const hoverElementsClassNames = [
        {
          elmToHover: thisComponent.getElementsByClassName("closeBtn")[0],
          classNames: "closeBtn",
        },
        {
          elmToHover: thisComponent.getElementsByClassName("button-l")[0],
          classNames: "button-l",
        },
      ];
      ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    } catch (e) {
      this.props.logFileCreation({
        error: e.message,
        originFunction: "afterOpenModal",
        component: "PendingComponent",
      });
    }
  }

  closeRptModal = (event) => {
    try {
      this.setState({ showRptDialog: false });
    } catch (e) {
      this.props.logFileCreation({
        error: e.message,
        originFunction: "closeRptModal",
        component: "PendingComponent",
      });
    }
  };

  handleIconClick = (row) => {
    this.setState({ showViewModal: true });
    this.setState({ selectedRow: row });
  };

  closeViewModal = () => {
    this.setState({ showViewModal: false });
  };

  Cell = (props) => {
    const { column, row } = props;

    // Find the column definition so we can see if it has align: 'right'
    const colDef = this.state.columns.find((c) => c.name === column.name);
    const isRightAligned = colDef?.align === "right";

    if (column.id === "action") {
      return (
        <Table.Cell {...props} fixedRight={true}>
          <img
            className={deliveryStyles.viewIcon}
            src={
              this.props.selectedCssColor === "DR"
                ? eyeIconWhiteUrl
                : eyeIconUrl
            }
            onClick={() => this.handleIconClick(row)}
            alt="view"
            width={16}
            height={16}
          />
        </Table.Cell>
      );
    }

    if (column.name === "DOCS") {
      const docs = row[column.name];
      return (
        <Table.Cell {...props}>
          {Array.isArray(docs)
            ? docs.map((doc, idx) => <div key={idx}>{doc}</div>)
            : docs || "-"}
        </Table.Cell>
      );
    }
    return (
      <Table.Cell
        {...props}
        style={{
          textAlign: isRightAligned ? "right" : "left",
          ...props.style,
        }}
      />
    );
  };

  constructor(props) {
    super(props);

    const baseColumns = [
      {
        name: "DRN",
        title: i18next.t("deliveryRequestNo"),
        width: { wpx: 90 },
      },
      { name: "AD", title: i18next.t("account"), width: { wpx: 90 } },
      { name: "CMDTY", title: i18next.t("cmdty"), width: { wpx: 90 } },
      {
        name: "TOTAL_GQ",
        title: i18next.t("quantity") + " " + this.props.userDetail.CompanyBaseName,
        width: { wpx: 90 },
        align: "right",
      },
      {
        name: "TOTAL_FC_PAMT",
        title: i18next.t("premAmt"),
        width: { wpx: 90 },
        align: "left",
      },
      {
        name: "TOTAL_PAMT",
        title: i18next.t("premAmt") + " (USD)",
        width: { wpx: 90 },
        align: "right",
      },
      // PremCharges Trn Id column will be added in this position conditionally
      { name: "LOC_DESC", title: i18next.t("location"), width: { wpx: 90 } },
      {
        name: "COLLECTIONDATETIME",
        title: i18next.t("collectionDateTime"),
        width: { wpx: 90 },
      },
      { name: "RMK", title: i18next.t("comments"), width: { wpx: 90 } },
      { name: "STATUSDESC", title: i18next.t("status"), width: { wpx: 90 } },
      { name: "TS", title: i18next.t("eventTime"), width: { wpx: 90 } },
      { name: "", title: "", id: "action", width: { wpx: 90 } },
    ];

    const comparePriority = (a, b) => {
      return toEpoch(a) - toEpoch(b);
    };

    if (!this.props.userDetail.premiumChargedOnDelivery) {
      baseColumns.splice(6, 0, {
        name: "DOCS",
        title: i18next.t("premChgsTrnID"),
        width: { wpx: 90 },
      });
    }
    this.state = {
      rows: [],
      columns: baseColumns,
      baseColumnsExtensions: baseColumnsExtensions,
      searchValue: "",
      pageSizes: [10, 15, 20, 0],
      selectedRow: {},
      showRptDialog: false,
      integratedSortingColumnExtensions: [
        { columnName: "COLLECTIONDATETIME", compare: comparePriority },
      ],
      numericColumns: ["TOTAL_GQ", "TOTAL_PAMT", "TOTAL_FC_PAMT"],
    };
  }

  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    setDirection(thisComponent, directionData, this.props.selectedLang);

    const root = ReactDOM.findDOMNode(this);
    setDirection(root, directionData, this.props.selectedLang);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const root = ReactDOM.findDOMNode(this);
      setDirection(root, directionData, nextProps.selectedLang);
    }
    
    if (nextProps.deliveryData !== this.props.deliveryData) {
      const mappedRows = (nextProps.deliveryData || []).map((row) => ({
        ...row,
        AD: row.AC && row.AD ? `${row.AC} - ${row.AD}` : row.AD || "",
        TZ: row.TZ || "",
        COLLECTIONDATETIME:
          [row.DATE, row.TIME, row.NOTATION, row.TZ]
            .filter(Boolean)
            .join(" ") ||
          row.TZ ||
          "",
      }));

      this.setState({ rows: mappedRows.filter((item) => item.STATUSDESC === "Pending") });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedLang !== this.props.selectedLang) {
      const root = ReactDOM.findDOMNode(this);
      setDirection(root, directionData, this.props.selectedLang);
    }
  }

  changeSearch = (searchValue) => {
    this.setState({ searchValue });
  };

  changeFlag = () => {
    this.setState({ showRptDialog: true });
  };

  generatePdf = (format) => {
    try {
      const startDate = moment().format("DD-MM-YYYY");
      const user = JSON.parse(localStorage.getItem("user"));
      const platform = localStorage.getItem("platform");
      const region = navigator.language;
      let response = "";
      if (
        this.state.rows.length === 0 ||
        this.state.rows === "" ||
        this.state.rows === null
      ) {
        this.setState({ showRptDialog: true });
      } else if (format === "PDF") {
        var xhr = new XMLHttpRequest();
        xhr.open(
          "GET",
          getPath("api") + "/user/generateDeliveryPDF?isTrader=true&type=P"
        );
        xhr.setRequestHeader("SID", this.props.userDetail.SID);
        xhr.setRequestHeader("username", this.props.userDetail.UID);
        xhr.setRequestHeader("location", user.location);
        xhr.setRequestHeader("Cache-Control", "no-cache");
        xhr.setRequestHeader("platform", platform);
        xhr.responseType = "blob";
        xhr.onload = function (dispatch) {
          if (xhr.status === 200) {
            filesaver.saveAs(
              xhr.response,
              "Delivery_Pending_Requests_" + startDate + ".pdf"
            );
          } else {
            this.changeFlag();
          }
        }.bind(this);
        xhr.send();
      }
    } catch (err) {
      console.error("Error generating report:", err);
    }
  };

  eventTimeCoverter = ({ value }) => {
    return <span>{convertEpochToEventTime(value)}</span>;
  };


  render() {
    const { selectedCssColor } = this.props;
    const { rows, columns, searchValue, pageSizes } = this.state;
    const shouldPage = rows?.length > pageSizes[0];

    const multiDataSet = [
      {
        columns: columns.map((col) => ({
          title: col.title,
          width: { wpx: 150 },
        })),
        data: rows.map((row) =>
          columns.map((col) => formatExcelValue(row[col.name], row, col))
        ),
      },
    ];

    const pagingPanelMessages = {
      showAll: i18next.t("all"),
      rowsPerPage: i18next.t("rowsPerPage"),
      info: "",
    };
    const PagingContainer = (props) => (
      <PagingPanel.Container {...props} className="pagingPanelDiv" />
    );
    const PagingContainerdark = (props) => (
      <PagingPanel.Container {...props} className="pagingPanelDivDark" />
    );

    const PagingStateComponent = shouldPage ? (
      <PagingState defaultCurrentPage={0} defaultPageSize={pageSizes[0]} />
    ) : null;
    const IntegratedPagingComponent = shouldPage ? <IntegratedPaging /> : null;

    return (
      <div id="pendingReqTab" className={`${this.props.language}`}>
        <Modal
          isOpen={this.state.showRptDialog}
          className={styles.warningModal}
          id="pendingRqstsModal"
          onAfterOpen={this.afterOpenModal}
        >
          <div ref="errorMSG" className="mdlWrap">
            <div className={`${styles.header} header`}>
              <span className={`${styles.msgTitle}`}>
                {i18next.t("pendingRequests")}
              </span>
              <span
                onClick={this.closeRptModal}
                className={`${styles.closeImg} closeIcon`}
                id="pendingRqstsCloseIcon"
              >
                {this.props.closeIcon}
              </span>
            </div>
            <div className={`${styles.msg} commonMsgDir`}>
              {i18next.t("noDataAvlMsg")}
            </div>
            <div className={`${styles.btnWrap} col-md-12`}>
              <Button
                className="button-l"
                bsStyle="primary"
                onClick={this.closeRptModal}
                id="pendingRqstsCloseBtn"
              >
                {i18next.t("OK")}
              </Button>
            </div>
          </div>
        </Modal>
        <div
          className={`${deliveryStyles.pendingTabOpenPos} pendingTableOpenPos ${this.props.selectedCssColor}`}
          id="actLogDiv"
        >
         <OpenPositions />

          <div
            className={`${styles.exportfileBaracc} pendingReqExportDiv ${deliveryStyles.delPenExport}`}
          >
            <label
              className={
                this.state.loadtableflag === true ? "disableLabel" : null
              }
            >
              {this.state.rows?.length !== 0 && (
                <span>
                  <ExcelFile
                    filename="DeliveryPendingRequests"
                    element={<img src="/images/xls.png" />}
                  >
                    <ExcelSheet
                      dataSet={multiDataSet}
                      name="DeliveryPendingRequests"
                    />
                  </ExcelFile>
                </span>
              )}
              {this.state.rows?.length === 0 && (
                <img src="/images/xls.png" onClick={this.changeFlag} />
              )}
              <span>
                <img
                  src="/images/pdf.png"
                  onClick={() => {
                    this.generatePdf("PDF");
                  }}
                  id="delPendingReqPDF"
                />
              </span>
            </label>
          </div>
        </div>
        <div
          className={`${deliveryStyles.deliveryTbl} deliveryTbl`}
          id="activitytbl"
        >
          <div className="reportsTblGrid">
            <Grid rows={rows} columns={columns}>
                <DataTypeProvider
                  for={this.state.numericColumns}
                  formatterComponent={({ column, row, value }) => {
                    const config = {
                        TOTAL_GQ: { ...getMinMaxFractionDigits(row.stockQtyFormat), roundOff: row.stockQtyRound },
                        TOTAL_PAMT: { ...getMinMaxFractionDigits(row.stockRateFormat), roundOff: row.stockRateRound },
                        TOTAL_FC_PAMT: { ...getMinMaxFractionDigits(row.stockRateFormat), roundOff: row.stockRateRound }
                    }[column.name] || {};

                    const { minimumFractionDigits, maximumFractionDigits, roundOff } = config;

                    const formattedValue = getFormattedRate(
                      value,
                      minimumFractionDigits,
                      maximumFractionDigits,
                      true,
                      roundOff
                    );

                    if (column.name === "TOTAL_FC_PAMT") {
                      return (
                        <span>
                          {formattedValue}
                          {row.CURRENCY ? ` ${row.CURRENCY}` : " USD"}
                        </span>
                      );
                    }
                    return  <span>{formattedValue}</span>;
                    }}
                />

              <DataTypeProvider
                for={["TS"]}
                formatterComponent={this.eventTimeCoverter}
              />

              <SortingState
                defaultSorting={[
                  { columnName: "COLLECTIONDATETIME", direction: "asc" },
                ]}
                columnExtensions={[
                  { columnName: "COLLECTIONDATETIME", sortingEnabled: true },
                ]}
              />
              <IntegratedSorting
                columnExtensions={this.state.integratedSortingColumnExtensions}
              />

              {PagingStateComponent}
              {IntegratedPagingComponent}

              <SearchState
                value={searchValue}
                onValueChange={this.changeSearch}
              />
              <IntegratedFiltering />

              <Table
                noDataCellComponent={NoDataCell}
                cellComponent={this.Cell}
                messages={{ noData: i18next.t("noDataAvlMsg") }}
                columnExtensions={this.state.baseColumnsExtensions}
              />
              <TableHeaderRow showSortingControls />
              <Toolbar />
              <SearchPanel />
              <TableColumnVisibility />
              {shouldPage && (
                <PagingPanel
                  pageSizes={pageSizes}
                  messages={pagingPanelMessages}
                  containerComponent={
                    selectedCssColor === "DR"
                      ? PagingContainerdark
                      : PagingContainer
                  }
                />
              )}
            </Grid>
          </div>
        </div>
        <ViewStatus
          isOpen={this.state.showViewModal}
          onClose={this.closeViewModal}
          rowData={this.state.selectedRow}
        />
      </div>
    );
  }
}